import { Badge, ProgressBar, Text } from '@shopify/polaris';
import { StyledYourAccount } from './styled';
import { calcPercent, capitalizeFirstLetter } from '@/helpers';
import { useGetUserPlanQuery } from '@/redux/api/api.caller';
import { AccountPlan } from '@/constants/enum';
import { ProgressPercent } from '../../config';
import { useMemo } from 'react';
import { UNLIMITED_QUOTA } from '@/pages/Plan/config';
import { getQuotaPerMonth } from '@/helpers';

const YourAccount = () => {
  const { data: userPlanData } = useGetUserPlanQuery({});

  const yourAccountInfo = useMemo(() => {
    if (userPlanData && userPlanData.data) {
      const { plan, isOldUser, credit, billingSummary } = userPlanData.data;
      const totalQuota = getQuotaPerMonth(userPlanData.data);
      const isUnlimitedQuota = totalQuota === UNLIMITED_QUOTA;
      const progressPercent = isUnlimitedQuota ? 0 : calcPercent(credit, Number(totalQuota));
      const isOldEnterpriseAccount = isOldUser && plan === AccountPlan.Enterprise;

      const renderProgressBarColor = () => {
        if (progressPercent < ProgressPercent.Warning) {
          return 'primary';
        }
        if (progressPercent < ProgressPercent.Critical) {
          return 'highlight';
        }
        return 'critical';
      };

      return {
        credit,
        progressPercent,
        isOldEnterpriseAccount,
        totalQuota,
        isUnlimitedQuota,
        progressBarColor: renderProgressBarColor(),
        planLabel: capitalizeFirstLetter(billingSummary.displayPlan),
      };
    }
    return null;
  }, [userPlanData]);

  return (
    yourAccountInfo &&
    (() => {
      const { credit, isOldEnterpriseAccount, progressBarColor, progressPercent, totalQuota, isUnlimitedQuota, planLabel } = yourAccountInfo;
      const quotaText = isOldEnterpriseAccount ? (
        <>
          Your quota: <Badge tone="success">{capitalizeFirstLetter(totalQuota.toString())}</Badge>
        </>
      ) : (
        <>
          Quota: {isUnlimitedQuota ? capitalizeFirstLetter(UNLIMITED_QUOTA) : `${credit}/${totalQuota}`}
        </>
      );

      return (
        <StyledYourAccount>
          <Text variant="bodySm" as="p">
            Plan: <strong>{planLabel}</strong> - {quotaText}
          </Text>
          {!isOldEnterpriseAccount && (
            <div className="shipment-statistics">
              <ProgressBar progress={progressPercent} tone={progressBarColor as any} size="small" />
            </div>
          )}
        </StyledYourAccount>
      );
    })()
  );
};

export default YourAccount;
